import axios from 'axios';

export default {
    methods: {
        exportExcel(url, data) {
            axios({
                url,
                method: 'post',
                data,
                headers: { 'content-type': 'application/json; charset=utf-8' },
                responseType: 'blob',
            })
                .then((res) => {
                    this.downloadFile(res.data, `${this.$t('processInspectionSearch.t57')}.xlsx`);
                });
        },
        autoSearch() {
            this.$refs.pageForm.$refs.queryForm.handleSubmit();
        },
        // 从至查询条件补全
        fromToValCheck() {
            const keys = [
                {
                    key: ['checkDateBegin', 'checkDateEnd'],
                },
                {
                    key: ['needByDateBegin', 'needByDateEnd'],
                },
            ];
            keys.forEach((item) => {
                const key1 = this.getFormDataItemObj(this.formData.items, item.key[0]);
                const key2 = this.getFormDataItemObj(this.formData.items, item.key[1]);
                if (key1 && key2) {
                    if (!key1.value || !key2.value) {
                        if (key1.value) {
                            this.$set(key2, 'value', key1.value);
                        } else if (key2.value) {
                            this.$set(key1, 'value', key2.value);
                        }
                    }
                }
            });
        },
    },
    mounted() {
        this.getSRMInvLovListNew((data) => {
            data.forEach((item) => {
                item.label = item.organizationName;
                item.value = item.organizationCode;
            });
            this.orgList = data;
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = data;
        });
    },
};
